import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as senderIdListActions from "../actions/sender_id_list_actions";
import * as senderIdListTypes from "../types/sender_id_list_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfSenderId(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_SENDER_ID_LIST, action.payload);
    if (res.status === 200) {
      yield put(senderIdListActions.getListOfSenderIdSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(senderIdListActions.getListOfSenderIdError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(senderIdListActions.getListOfSenderIdError(e));
  }
}

function* editSenderId(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_SENDER_ID_LIST}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(senderIdListActions.editSenderIdSuccess(res.data));
      yield put(senderIdListActions.getListOfSenderIdRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(senderIdListActions.editSenderIdError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(senderIdListActions.editSenderIdError(e));
  }
}

export default function* senderIdListSaga() {
  yield takeLatest(senderIdListTypes.getListOfSenderId.GET_LIST_OF_SENDER_ID_REQUEST, getListOfSenderId);
  yield takeLatest(senderIdListTypes.editSenderId.EDIT_SENDER_ID_REQUEST, editSenderId);
}
